import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { FilePdf } from "@phosphor-icons/react";
import { api, API } from "@/lib/api";
import { Seo } from "@/components/Seo";
import { Logo } from "@/components/Logo";
import ReportContent from "@/components/ReportContent";

export default function PublicReport() {
  const { id } = useParams();
  const [report, setReport] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get(`/public/reports/${id}`).then((r) => setReport(r.data)).catch(() => setError(true));
  }, [id]);

  if (error) {
    return <Center>Rapor bulunamadı veya henüz hazır değil.</Center>;
  }
  if (!report) {
    return <Center>Yükleniyor…</Center>;
  }
  if (report.status !== "done") {
    return <Center>Bu rapor henüz hazırlanıyor. Lütfen daha sonra tekrar gelin.</Center>;
  }

  return (
    <div className="min-h-screen bg-background">
      <Seo
        title={`${report.brand_name} — AI Marka Radar Skoru ${report.overall_score}/100 | AI Marka Radar`}
        description={`${report.brand_name} markasının ChatGPT, Gemini ve Perplexity üzerindeki yapay zekâ görünürlük raporu. Skor: ${report.overall_score}/100.`}
        path={`/r/${report.id}`}
        image={`${API}/public/reports/${report.id}/og.png`}
      />
      <header className="no-print sticky top-0 z-40 bg-background/70 backdrop-blur-xl border-b border-border">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <Logo />
          <button onClick={() => window.print()} data-testid="public-pdf-btn"
            className="flex items-center gap-1.5 bg-brand text-white px-4 py-2.5 text-sm font-medium">
            <FilePdf size={16} /> PDF indir
          </button>
        </div>
      </header>
      <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="mb-8 no-print">
          <p className="font-mono text-xs tracking-[0.2em] uppercase text-brand mb-1">Paylaşılan Rapor</p>
          <p className="text-sm text-muted-foreground">Bu rapor herkese açık olarak paylaşıldı.</p>
        </div>
        <ReportContent report={report} />
        <footer className="mt-16 pt-8 border-t border-border text-center">
          <p className="font-mono text-xs text-muted-foreground">AI Marka Radar ile oluşturuldu · ai-gorunurluk</p>
        </footer>
      </main>
    </div>
  );
}

const Center = ({ children }) => (
  <div className="min-h-screen flex items-center justify-center bg-background">
    <p className="font-mono text-sm text-muted-foreground animate-pulse">{children}</p>
  </div>
);
